import { takeLatest } from "redux-saga/effects";

import { Action } from "../../App/ClassManagement/actions";
import * as actions from "../../App/ClassManagement/actions";
import { deleteClass, fetchClass, fetchInitialData, patchClass } from "../../App/ClassManagement/actions/sagas";

export function* watchFetchClass() {
  yield takeLatest(
    Action.FETCH_INITIAL_DATA,
    fetchInitialData({
      onFailure: actions.handleFetchInitialDataFailure,
      onSuccess: actions.handleFetchInitialDataSuccess,
    })
  );
}

export function* watchRefreshClass() {
  yield takeLatest(
    Action.REFRESH_CLASS,
    fetchClass({
      onFailure: actions.refreshClassFailure,
      onSuccess: actions.refreshClassSuccess,
    })
  );
}

export function* watchPatchClass() {
  yield takeLatest(
    Action.PATCH_CLASS_REQUEST,
    patchClass({
      onFailure: actions.patchClassRequestFailure,
      onSuccess: actions.patchClassRequestSuccess,
    })
  );
}

export function* watchDeleteClass() {
  yield takeLatest(
    Action.DELETE_CLASS,
    deleteClass({
      onFailure: actions.handleDeleteClassFailure,
      onSuccess: actions.handleDeleteClassSuccess,
    })
  );
}
